export default __webpack_public_path__ + "static/media/fair_credit.ea833a79.svg";